import styled from 'styled-components'
import { noop } from 'lodash'

import { breakpoints } from '@/styles'
import { isEmptyOrNull } from '@/utils'
import useSessionComplete from '@/hooks/use-session-complete'
import { useListImpressionTracking } from '@/components/ImpressionProvider/useListImpressionTracking'
import SkeletonCard from '@/components/listing-card-new/SkeletonCard'
import { getClickEventId } from '@/components/listing-card/utils'
import { useTermsDialogContext } from '@/components/terms-dialog/context'

import { MessageModalProvider } from '../ListingsMap/map-list/context'
import { ListingCardItem } from '../ListingsMap/map-list/listing-card-item'

const Wrapper = styled.div`
  margin: 24px auto 100px;
`

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 320px);
  grid-gap: 20px;
  justify-content: flex-start;
  align-content: start;

  @media screen and (max-width: ${breakpoints.desktop}) {
    grid-template-columns: repeat(auto-fill, 350px);
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    grid-template-columns: repeat(auto-fill, 100%);
    justify-content: start;
    padding-left: 20px;
    padding-right: 20px;
  }
`

const renderSkeletonCards = count => {
  return Array.from({ length: count }, (_, index) => (
    <SkeletonCard key={`skeleton-${index}`} />
  ))
}

const CardList = ({
  children = null,
  listings = [],
  noSchema,
  loading = false
}) => {
  const isLoggedIn = useSessionComplete()
  const { checkAgreementMismatch, isLoading } = useTermsDialogContext()
  const isAgreementMismatched = checkAgreementMismatch('trreb_agreements')
  const isAgreementLoading = isLoading && isLoggedIn
  useListImpressionTracking({ id: 'similar-listings', minVisibleDuration: 0 })

  if (loading && isEmptyOrNull(listings)) return renderSkeletonCards(3)

  return (
    <Wrapper data-impression-container="true">
      <GridWrapper>
        <MessageModalProvider>
          {children}
          {listings.map(listing => {
            return (
              <ListingCardItem
                id={getClickEventId(listing, false, '')}
                key={listing.listing_id}
                listing={listing}
                hasSession={isLoggedIn}
                isAgreementMismatched={isAgreementMismatched}
                isAgreementLoading={isAgreementLoading}
                onListingHover={noop}
                onClick={noop}
              />
            )
          })}
        </MessageModalProvider>
      </GridWrapper>
    </Wrapper>
  )
}

export default CardList
